import {Box, IconButton, Menu, MenuItem, useTheme} from "@mui/material";
import React, {useState} from "react";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import LanguageIcon from "@mui/icons-material/Language";

import {useTranslation} from "react-i18next";

const HeaderControls = ({ toggleColorMode }) => {
    const { i18n } = useTranslation();
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState(null);
  
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        };

    const handleClose = (lng) => {
        setAnchorEl(null);
        if (lng) {
            i18n.changeLanguage(lng);
            }
        };

    return <Box sx={{ position: 'absolute', top: 16, right: 16, zIndex: 10, display: 'flex', gap: 1 }}>
                <IconButton onClick={toggleColorMode} size="small" color="inherit">
                    {theme.palette.mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
                </IconButton>
                <IconButton onClick={handleClick} size="small" color="inherit">
                    <LanguageIcon />
                </IconButton>
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => handleClose()}>
                    <MenuItem onClick={() => handleClose('en')}>English</MenuItem>
                    <MenuItem onClick={() => handleClose('de')}>Deutsch</MenuItem>
                </Menu>
            </Box>;
    
    };

export default HeaderControls;